(function(){
  // Zones de paiements accélérés à masquer tant que non coché
  const WALLET_ZONES = [
    '.shopify-payment-button',
    '.additional-checkout-buttons',
    '.dynamic-checkout__content'
  ];
  // Boutons checkout : page panier + mini-cart + web component
  const CHECKOUT_BTNS = [
    'button[name="checkout"]',
    '.mini-cart-footer-actions button[name="checkout"]',
    'cart-checkout-button button',
    'a[href*="/checkout"]'
  ];

  const qsa = (sel, scope=document) => Array.from(scope.querySelectorAll(sel));

  // ----- Helpers consent -----
  function getConsentBlocks(){
    return Array.from(document.querySelectorAll('#backorder-consent, #backorder-consent-mini'));
  }
  function consentRequired(){ return getConsentBlocks().length > 0; }
  function consentChecked(){
    return getConsentBlocks().some(b => {
      const cb = b.querySelector('input[type="checkbox"]');
      return cb && cb.checked;
    });
  }
  function setHiddenValues(checked){
    getConsentBlocks().forEach(b => {
      const hidden = b.querySelector('input[type="hidden"][name^="attributes[Acceptation délais backorder]"]');
      if (hidden) hidden.value = checked ? 'Oui' : 'Non';
    });
  }
  function toggleWallets(show){
    WALLET_ZONES.forEach(sel => qsa(sel).forEach(el => { el.style.display = show ? '' : 'none'; }));
  }

  // ✅ PATCH : désactiver réellement les boutons quand possible
  function toggleCheckoutVisual(blocked){
    CHECKOUT_BTNS.forEach(sel => qsa(sel).forEach(btn => {
      if (blocked){
        btn.classList.add('bo-disabled');
        btn.setAttribute('aria-disabled','true');
        if (btn.tagName === 'BUTTON' || btn.tagName === 'INPUT') btn.disabled = true;
      } else {
        btn.classList.remove('bo-disabled');
        btn.removeAttribute('aria-disabled');
        if (btn.tagName === 'BUTTON' || btn.tagName === 'INPUT') btn.disabled = false;
      }
    }));
  }

  function flashBlock(){
    const b = getConsentBlocks()[0];
    if (!b) return;
    b.scrollIntoView({behavior:'smooth', block:'center'});
    b.style.boxShadow = '0 0 0 2px rgba(220,38,38,.4)';
    setTimeout(() => { b.style.boxShadow = ''; }, 600);
  }

  // --- Persister l'attribut côté panier UNIQUEMENT quand l'utilisateur (dé)coche ---
  function persistCartAttribute(checked){
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ attributes: { 'Acceptation délais backorder': checked ? 'Oui' : 'Non' } })
    }).catch(() => {});
  }

  // --- Forcer l'attribut juste avant de partir au checkout ---
  async function ensureAttrBeforeCheckout(){
    if (!consentRequired()) return true;
    if (!consentChecked()) return false;
    try{
      const res = await fetch('/cart/update.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        credentials:'same-origin',
        body: JSON.stringify({ attributes: { 'Acceptation délais backorder': 'Oui' } })
      });
      return res.ok;
    }catch(_){ return false; }
  }

  function isCartForm(form){
    return form instanceof HTMLFormElement
      && /\/cart/.test(form.getAttribute('action') || '')
      && (form.method || '').toLowerCase() === 'post';
  }

  // Évalue l'état global et applique (aucun appel réseau ici)
  function refresh(){
    if (!consentRequired()) return;
    const ok = consentChecked();
    setHiddenValues(ok);
    toggleWallets(ok);
    toggleCheckoutVisual(!ok);
  }

  // Empêcher l’auto-submit du mini-cart quand on (dé)coche la case
  function wireCheckboxes(){
    getConsentBlocks().forEach(b => {
      const cb = b.querySelector('input[type="checkbox"]');
      if (!cb || cb.dataset.boWired) return;
      cb.dataset.boWired = '1';

      const stopper = (e) => { e.stopPropagation(); setTimeout(refresh, 0); };
      ['click','change','input'].forEach(evt => cb.addEventListener(evt, stopper, true));

      cb.addEventListener('change', () => { persistCartAttribute(cb.checked); }, false);
    });
  }

  // === PATCH interceptCheckout ===
  function interceptCheckout(){
    const CLICK_SELS = [
      'button[name="checkout"]',
      'button[id^="checkout"]',
      '[data-checkout-button]',
      '.mini-cart-footer-actions button[name="checkout"]',
      'cart-checkout-button button',
      'a[href*="/checkout"]',
      '.cart__submit',
      '.cart-footer [type="submit"]'
    ];

    // ✅ PATCH : gérer aussi pointerdown/touchstart (mobile)
    const handleCheckoutIntent = async (e) => {
      const btn = CLICK_SELS.map(sel => e.target.closest(sel)).find(Boolean);
      if (!btn) return;

      if (consentRequired() && !consentChecked()) {
        e.preventDefault(); e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        flashBlock(); return;
      }

      if (consentRequired() && consentChecked()) {
        e.preventDefault(); e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        const ok = await ensureAttrBeforeCheckout();
        if (ok) {
          const form = btn.closest('form');
          if (btn.tagName === 'A' && btn.href) window.location.href = btn.href;
          else if (form) form.submit();
          else window.location.assign('/checkout');
        } else {
          flashBlock();
        }
      }
    };

    ['pointerdown','touchstart','click'].forEach(evt => {
      document.addEventListener(evt, handleCheckoutIntent, true);
    });

    // 2) Submit du form panier (couvre Safari iOS sans e.submitter)
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!isCartForm(form)) return;

      if (consentRequired() && !consentChecked()) {
        e.preventDefault(); flashBlock(); return;
      }
      if (consentRequired() && consentChecked()) {
        e.preventDefault();
        const ok = await ensureAttrBeforeCheckout();
        if (ok) form.submit(); else flashBlock();
      }
    }, true);
  }

  function init(){ wireCheckboxes(); refresh(); }

  document.addEventListener('DOMContentLoaded', () => {
    interceptCheckout();
    init();
    // Hydrater l’UI depuis le panier (si attribut déjà présent)
    fetch('/cart.js',{credentials:'same-origin'})
      .then(r=>r.json())
      .then(cart=>{
        const val = cart?.attributes?.['Acceptation délais backorder'];
        const checked = (val === 'Oui');
        getConsentBlocks().forEach(b=>{
          const cb = b.querySelector('input[type="checkbox"]');
          if (cb) cb.checked = checked;
        });
        setHiddenValues(checked);
        refresh();
      }).catch(()=>{});
  });

  const mo = new MutationObserver(() => { wireCheckboxes(); refresh(); });
  mo.observe(document.body, { childList:true, subtree:true });

  /* === PATCH CART PAGE : nettoyer encarts & libérer les boutons quand il n'y a plus de backorder === */
  function onCartPage(){
    return !!document.querySelector('form[action*="/cart"][method="post"]');
  }

  let cartAuditTimer = null;
  function scheduleCartAudit(delay = 450){
    clearTimeout(cartAuditTimer);
    cartAuditTimer = setTimeout(auditAndCleanupCartPage, delay);
  }

  async function auditAndCleanupCartPage(){
    if (!onCartPage()) return;
    try{
      const cart = await fetch('/cart.js', { credentials:'same-origin' }).then(r=>r.json());
      if (!cart?.items?.length){
        ['backorder-consent','backorder-consent-mini'].forEach(id=>{
          const el = document.getElementById(id);
          if (el) el.remove();
        });
        toggleWallets(true);
        toggleCheckoutVisual(false);
        return;
      }

      const checks = await Promise.all(cart.items.map(async it => {
        try{
          const p = await fetch(`/products/${it.handle}.js`, { credentials:'same-origin' }).then(r=>r.json());
          const v = p.variants.find(v => v.id == it.variant_id);
          if (!v) return false;
          const tracks = !!v.inventory_management;
          const cont   = (v.inventory_policy || '').toLowerCase() === 'continue';
          const invQty = typeof v.inventory_quantity === 'number' ? v.inventory_quantity : 0;
          return tracks && cont && (invQty < it.quantity);
        } catch(_) { return true; }
      }));

      const needConsent = checks.some(Boolean);

      if (!needConsent){
        ['backorder-consent','backorder-consent-mini'].forEach(id=>{
          const el = document.getElementById(id);
          if (el) el.remove();
        });
        toggleWallets(true);
        toggleCheckoutVisual(false);
      } else {
        refresh();
      }
    } catch(_){ /* ignore */ }
  }

  document.addEventListener('click', (e) => {
    if (!onCartPage()) return;
    const selectors = [
      'a[href*="/cart/change"]',
      '[name="remove"]',
      '.cart-remove',
      '[data-cart-remove]',
      'button[aria-label*="remove"]',
      '.quantity__button'
    ];
    if (selectors.some(sel => e.target.closest(sel))) {
      scheduleCartAudit();
    }
  }, true);

  document.addEventListener('change', (e) => {
    if (!onCartPage()) return;
    if (e.target.matches('input[name^="updates"], input[type="number"][name^="updates"]')) {
      scheduleCartAudit();
    }
  }, true);
  /* === /PATCH === */

})();
